<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>{{mode == MODE_APPROVE ? '入金突合承認画面' : '入金突合画面'}}</h1>

<form [formGroup]="searchConditionForm" (ngSubmit)="search()">
    <!-- 検索条件コンポーネント -->
    <app-sgke120d-search-condition *ngIf="initialhyojiInfo" [mode]="mode" [initialhyojiInfo]="initialhyojiInfo" [businessDate]="businessDate"
        (onClickClearEmitter)="clear()"></app-sgke120d-search-condition>
</form>

<!-- 検索結果コンポーネント -->
<app-sgke120d-search-result *ngIf="showResult" [mode]="mode" [searchresultList]="searchresultList"
    [confirmzumiKafusokuRuikei]="confirmzumiKafusokuRuikei" [hyojiBalanceSum]="hyojiBalanceSum"
    (onClickReportEmitter)="report($event)"
    (onClickApprovalEmitter)="approval($event)"
    (onDblClickRowEmitter)="navigateToDetailOnDblClickRow($event)"></app-sgke120d-search-result>